import { useEffect, useRef } from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { useDocumentHead } from '@/hooks/useDocumentHead';

export default function Blog() {
  useDocumentHead({
    title: 'Say It NOW Journal | Blog',
    description: 'Stories, tips, and inspiration for expressing love and gratitude to the people who matter most.',
    path: '/blog',
  });

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const params = new URLSearchParams(window.location.search);
    let src = 'https://app.trysoro.com/api/embed/e7fc265b-2ab5-471d-b027-4782365cc370';
    const post = params.get('post');
    if (post) src += '?post=' + encodeURIComponent(post);

    const script = document.createElement('script');
    script.src = src;
    containerRef.current.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1 container py-8 md:py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
          Say It NOW Journal
        </h1>
        <div
          id="soro-blog"
          ref={containerRef}
          className="prose prose-invert prose-lg max-w-none
            [&_*]:!text-gray-200
            [&_h1]:!text-white [&_h2]:!text-white [&_h3]:!text-white [&_h4]:!text-white
            [&_a]:!text-emerald-400 [&_a:hover]:!text-emerald-300
            [&_strong]:!text-white [&_b]:!text-white"
        />
      </main>
      <Footer />
    </div>
  );
}
